import React from "react";
// @material-ui/core components
import withStyles from "@material-ui/core/styles/withStyles";
// Link
import { Link } from "react-router-dom";
// @material-ui/icons
import ViewCarousel from "@material-ui/icons/ViewCarousel";
// core components
import GridContainer from "components/Grid/GridContainer.jsx";
import GridItem from "components/Grid/GridItem.jsx";
import Button from "components/CustomButtons/Button.jsx";
import InfoArea from "components/InfoArea/InfoArea.jsx";
import PlayArrow from "@material-ui/icons/PlayArrow";

import productStyle from "assets/jss/material-kit-pro-react/views/landingPageSections/productStyle.jsx";

class PDProgramSection extends React.Component {
  render() {
    const { classes } = this.props;
    return (
      <div className={classes.section}>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={8}>
            <h2 className={classes.title}>
              TEN Professional Development Program
            </h2>
            <h5 className={classes.description}>
              As part of TEN, a suite of 35 online professional development (PD)
              modules on teaching approaches, strategies and effective
              use of learning technologies will be offered. All these modules
              are mapped to the seven domains in the TEN Capability Framework
              and are designed to support teaching staff in the delivery of
              high-quality student learning experiences. The modules are
              flexible, each consisting of three hours of learning that can be
              completed online over a two-week period. Explore the PD
              Catalogue below:
            </h5>
          </GridItem>
        </GridContainer>
        <GridContainer justify="center">
          <GridItem xs={12} sm={12} md={4}>
            <InfoArea
              title="PD Catalogue"
              icon={ViewCarousel}
              iconColor="rose"
              vertical
            />
            <Link to={"/catalogue"}>
              <Button style={{ width: "60%" }} type="button" color="rose">
                <PlayArrow />
                Explore
              </Button>
            </Link>
          </GridItem>
        </GridContainer>
      </div>
    );
  }
}

export default withStyles(productStyle)(PDProgramSection);
